import {createApp} from 'vue'
import MemberOverlay from './MemberOverlay'

const el = '.kb-component--member-overlay'

export default function(Store){
    const DOM = document.querySelectorAll(el)
    if(DOM.length){
        DOM.forEach((MemberOverlayDOM)=>{
            const component = createApp(MemberOverlay).use(Store)
            component.mount(MemberOverlayDOM)
        })
    }
}